import React from 'react'

import {Card, Chip, withStyles} from 'material-ui'

import Hero from './Hero'
import MainNav from './MainNav'
import SignupForm from './SignupForm'
import TitledPage from './TitledPage'
import PlayButton from './PlayButton'
import VideoDialog from './VideoDialog'

const styles = theme => ({
    hero: {
        backgroundImage: 'url(/img/helping-senior-with-technology_925x.jpg)',
        backgroundSize: 'cover',
        minHeight: theme.layout.heroTotalHeight,
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: theme.layout.heroTotalHeight,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        position: 'relative',
        paddingLeft: 20,
        top: 80 - theme.layout.heroTotalHeight,
    },
    leftCol: {
        textAlign: 'left',
        maxWidth: 600,
        '& a': {
            color: theme.palette.contrast
        },
        '& h1': {
            ...theme.typography.display2,
            color: theme.palette.contrast,
        },
        '& h2': {
            ...theme.typography.headline,
            color: theme.palette.contrast,
        }
    },
    card: {
        border: '1px solid black',
        marginTop: 120,
        width: 400,
        padding: 20,
    },
    labels: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 4,
        color: theme.palette.contrast,
    },
    chip1: { backgroundColor: theme.palette.labels[0] },
    chip2: { backgroundColor: theme.palette.labels[1] },
    chip3: { backgroundColor: theme.palette.labels[2] },
    chip4: { backgroundColor: theme.palette.labels[3] },
    videoDiv: {
        display: 'flex',
        alignItems: 'center',
    },
})

export class Landing extends React.Component {
    constructor(props) {
        super(props)
        this.state = {videoOpen: false}
    }

    openPlayer = () => {
        this.setState({videoOpen: true})
    }

    closePlayer = () => {
        this.setState({videoOpen: false})
    }

    render() {
        const {classes} = this.props
        const {videoOpen} = this.state
        return (
            <TitledPage title="Carefol.io | help for caregivers">
                <VideoDialog open={videoOpen} onClose={this.closePlayer}/>
                <Hero className={classes.hero}>
                    <div className={classes.overlay}/>
                    <MainNav/>
                </Hero>
                <div className={classes.content}>
                    <div className={classes.leftCol}>
                        <h1>Caring for someone you love?</h1>
                        <h2>With <strong>carefol.io</strong> you can make things easier.</h2>
                        <div className={classes.labels}>
                            <Chip className={[classes.chip, classes.chip1].join(' ')} label="Organize medicines"/>
                            <Chip className={[classes.chip, classes.chip2].join(' ')} label="Keep track of appointments"/>
                            <Chip className={[classes.chip, classes.chip3].join(' ')} label="Enlist others to help with caregiving tasks"/>
                            <Chip className={[classes.chip, classes.chip4].join(' ')} label="Keep track of healthcare and caregiving contacts"/>
                        </div>
                        <div className={classes.videoDiv}>
                            <PlayButton onClick={this.openPlayer}/>
                            <h2>See how it works</h2>
                        </div>
                    </div>
                    <Card className={classes.card}>
                        <SignupForm />
                    </Card>
                </div>
            </TitledPage>
        )
    }
}

export default withStyles(styles)(Landing)


// WEBPACK FOOTER //
// ./src/components/Landing.jsx